import clsx from 'clsx';

import { Flex, Typography } from '@aloft/toolkit-sui';

import { useModuleContext } from '../../../modules/shared/moduleContext/useModuleContext.ts';
import { NavItemType } from './types.ts';
import { useIsSelectedNavItem } from './useIsSelectedNavItem.ts';

export const HeaderNavItem = ({
  item,
  to,
  isLegacyTopNav = false,
}: {
  item: NavItemType;
  to: string;
  isLegacyTopNav?: boolean;
}) => {
  const {
    navigation: { NavLink },
  } = useModuleContext();
  const isSelected = useIsSelectedNavItem(item.route);

  return (
    <Flex
      height="100%"
      alignItems="center"
      justifyContent="center"
      paddingLeft="0.5rem"
      paddingRight="0.5rem"
      position="relative"
    >
      <NavLink
        to={to}
        className={clsx(isLegacyTopNav && 'main-header-nav-item-link-legacy', 'main-header-nav-item-link')}
      >
        <Flex alignItems="center" gap="6px">
          <Typography variant="h3" color={isSelected ? 'textPrimary' : 'textTertiary'}>
            {item.label}
          </Typography>
        </Flex>
      </NavLink>
    </Flex>
  );
};
